import jwtDecode from "jwt-decode";

export const decodeToken = async (token: string) => {
  let payload;
  if (token && token !== "undefined") {
    payload = jwtDecode(token);
  }
  return payload;
};
